import { NotifyHelper } from "../../../helpers/toast";
import { eTrangThaiKhoActionTypeDefine } from "../../action-types/quan-ly-kho/ITrangThaiKhoActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const trangThaiKhoActions = {
    ...generateActions(eTrangThaiKhoActionTypeDefine, "TRANG_THAI_KHO"),
    ...generateActionForKey(eTrangThaiKhoActionTypeDefine, "TRANG_THAI_KHO", "LOAD_ERROR", (m) => { NotifyHelper.Error(m) }),
}
